import { render, staticRenderFns } from "./PreviewProject.vue?vue&type=template&id=28ea4bc0&scoped=true&"
import script from "./PreviewProject.vue?vue&type=script&lang=ts&"
export * from "./PreviewProject.vue?vue&type=script&lang=ts&"
import style0 from "./PreviewProject.vue?vue&type=style&index=0&id=28ea4bc0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28ea4bc0",
  null
  
)

export default component.exports